export default __webpack_public_path__ + "static/media/bg-blur-large.b5232a76.png";